import Text from "@ludens-reklame/rubics-theme/dist/components/Text";

export default Text;
